<div role="tabpanel" class="tab-pane checklist-tab-pane {{#if first}}active{{/if}} module {{key}}" id="{{key}}_pane">
  <div class="checklist-items"></div>
</div>
